/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-battery-low': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M15 15H3.75c-.69 0-1.25-.56-1.25-1.25v-7.5C2.5 5.56 3.06 5 3.75 5H15c.69 0 1.25.56 1.25 1.25v.625h.625c.69 0 1.25.56 1.25 1.25v3.75a1.252 1.252 0 01-1.25 1.25h-.625v.625A1.252 1.252 0 0115 15zM3.75 6.25v7.5H15v-1.875h1.875v-3.75H15V6.25H3.75zm2.5 1.25v5H5v-5h1.25z"/>'
  }
})
